<template>
  <div>
    <div class="cardbody" v-if="lc_data != null">
      <!-- <v-row dense style="font-weight: bolder" v-if="lc_data.udise_no != null && lc_data.school_code !=null "> -->

      <div v-if="org_basic_data.school_name == 'Zeal International School'">
        <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/zeal/CBSE+LETTERHEAD.jpg" alt="" width="100%" height="170"/>
        <center>
          <h2 style="margin-top: -11px; text-transform: uppercase;">Leaving Certificate</h2>
        </center>
      </div>
      <div v-else>
        <div dense v-if="lc_data.Affiliation_no != null"
          style="width: 50%;display: inline-block;font-size: 14px;font-family: arial;font-weight: bolder;">Affiliation
          No.:&nbsp;{{ lc_data.Affiliation_no }}</div>
        <div dense v-if="lc_data.school_code != null"
          style="width: 50%;display: inline-block;font-size: 14px;font-family: arial;font-weight: bolder;text-align:right">
          School Code.:&nbsp;{{ lc_data.school_code }}</div>
        <div>
          <div style="
            width: 22%;
            display: inline-block;
            font-size: 14px;
            font-family: arial;
          ">
            <img :src="org_basic_data.trust_logo" alt="" width="100%" />
            <span v-if="lc_data.udise_no != null">
              <b> UDISE No: {{ lc_data.udise_no }}</b>
            </span>
          </div>
          <div style="
            padding-left: 15px;
            width: 78%;
            display: inline-block;
            font-size: 14px;
            font-family: arial;
            padding-top: -10px;
          ">
            <center>
              <h3 class="trust-name">
                {{ org_basic_data.trust_name }}
              </h3>
              <h1 class="schl-name">
                {{ org_basic_data.school_name }}
              </h1>

              <h3 style="text-transform: uppercase">(English Medium)</h3>
            </center>
            <center>
              <span class="h2-span">{{ org_basic_data.address }}</span><br />

              <span class="h2-span"> Ph.No. {{ org_basic_data.phone }} </span>
              <span class="h2-span" style="margin-left: 5px">
                Email: {{ org_basic_data.email }}
              </span>
            </center>
            <center>
              <span class="line1 h2-span" v-html="org_basic_data.line1"></span><br />

              <span class="line2 h2-span" v-html="org_basic_data.line2"></span><br />
            </center>
            <br />
          </div>
        </div>
        <div class="lcdata">
          <!-- <v-col cols="12">
          <v-row dense style="font-weight: bolder">
            <v-col cols="12" md="4" sm="4">
              <span class="schl-info"
                >Affiliation No.:&nbsp;{{ lc_data.Affiliation_no }}</span
              >
            </v-col>
            <v-col cols="12" md="4" sm="4"></v-col>
            <v-col align="right" cols="12" md="4" sm="4"
              ><span class="schl-info"
                >School Code.:&nbsp;{{ lc_data.school_code }}</span
              ></v-col
            >
          </v-row>
        </v-col> -->
        </div>
        <center>
          <span>{{ lc_data.section_name }}</span>

          <div>
            <h2>Leaving Certificate</h2>
          </div>
        </center>
      </div>

      <!-- {{lc_data}} -->
      <div class="lcdata">
        <!-- <v-col cols="12">
          <v-row dense style="font-weight: bolder">
            <v-col cols="12" md="4" sm="4">
              <span class="schl-info"
                >Affiliation No.:&nbsp;{{ lc_data.Affiliation_no }}</span
              >
            </v-col>
            <v-col cols="12" md="4" sm="4"></v-col>
            <v-col align="right" cols="12" md="4" sm="4"
              ><span class="schl-info"
                >UDISE No.:&nbsp;{{ lc_data.udise_no }}</span
              ></v-col
            >
          </v-row>
        </v-col> -->
        <hr />
        <span v-if="org_basic_data.school_name === 'Zeal International School'" style="font-size: 11px; font-family: arial">
          Note:- No Change in any entry is to be made except by the authority
          issuing Certificate Infringenment of the rule will be punished with
          rustication.
        </span>
        <span v-else style="font-size: 14px; font-family: arial">
          Note:- No Change in any entry is to be made except by the authority
          issuing Certificate Infringenment of the rule will be punished with
          rustication.
        </span>
        <hr />

        <div style="width: 100%">
          <center>
            <div dense style="
                width: 35%;
                display: inline-block;
                font-size: 14px;
                font-family: arial;
                font-weight: bolder;
              ">
              General Register No. :- {{ lc_data.gr_number }}
            </div>
            <div dense style="
                width: 30%;
                display: inline-block;
                font-size: 20px;
                font-family: arial;
                font-weight: bolder;
              ">
              Original
            </div>
            <div dense style="
                width: 35%;
                display: inline-block;
                font-size: 14px;
                font-family: arial;
                font-weight: bolder;
              ">
              Certificate No. :- {{ lc_data.certificate_no }}
            </div>
          </center>
        </div>

        <table border="1" class="lc-table" style="
            width: 100%;
            font-size: 16px;
            font-family: arial;
            border-collapse: collapse;
          ">
          <tr>
            <td>1</td>
            <td style="width: 46%">{{ org_basic_data.school_name === 'Zeal International School' ? "Saral ID" : "Student Id" }}</td>
            <td class="tdata2">
              <span v-if="lc_data.saral_id !== null || lc_data.saral_id !== ''">
                {{ lc_data.saral_id }}</span>
            </td>
          </tr>
          <tr>
            <td>2</td>
            <td>UID(Aadhaar No)</td>
            <td class="tdata2">{{ lc_data.aadhar_no }}</td>
          </tr>
          <tr>
            <td>3</td>
            <td>PEN No</td>
            <td class="tdata2">{{ lc_data.pen_no }}</td>
          </tr>
          <tr v-if="org_basic_data.school_name === 'Zeal International School'">
            <td>4</td>
            <td>APAAR ID</td>
            <td class="tdata2">{{ lc_data.apaar_id }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 5 : 4 }}</td>
            <td>Name of the pupil in full</td>
            <td class="tdata2">{{ lc_data.fullname }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 6 : 5 }}</td>
            <td>Mother's Name</td>
            <td class="tdata2">{{ lc_data.mother_first_name }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 7 : 6 }}</td>
            <td>Religion and Caste-Subcaste</td>
            <td class="tdata2">{{ lc_data.religion }}-{{ lc_data.caste }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 8 : 7 }}</td>
            <td>Nationality</td>
            <td class="tdata2">{{ lc_data.nationality }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 9 : 8 }}</td>
            <td>Mother Tongue</td>
            <td class="tdata2">{{ lc_data.mothertoungue }}</td>
          </tr>
          <tr v-if="org_basic_data.school_name === 'Zeal International School'">
            <td>10</td>
            <td>Date of Birth, Month & Year according to Christian Era</td>
            <td class="tdata2">{{ lc_data.dob_fig }}-{{ lc_data.dob_words }}</td>
          </tr>
          <tr v-if="org_basic_data.school_name === 'Zeal International School'">
            <td>11</td>
            <td>Place of Birth</td>
            <td class="tdata2">{{ lc_data.birth_place }}</td>
          </tr>
          <tr v-if="org_basic_data.school_name === 'Zeal International School'">
            <td></td>
            <td>Birth Taluka</td>
            <td class="tdata2">{{ lc_data.birth_taluka }}</td>
          </tr>
          <tr v-if="org_basic_data.school_name === 'Zeal International School'">
            <td></td>
            <td>Birth District</td>
            <td class="tdata2">{{ lc_data.birth_district }}</td>
          </tr>
          <tr v-if="org_basic_data.school_name === 'Zeal International School'">
            <td></td>
            <td>Birth State</td>
            <td class="tdata2">{{ lc_data.birth_state }}</td>
          </tr>
          <tr v-if="org_basic_data.school_name === 'Zeal International School'">
            <td></td>
            <td>Birth Country</td>
            <td class="tdata2">{{ lc_data.birth_country_new }}</td>
          </tr>

          <tr v-if="org_basic_data.school_name !== 'Zeal International School'">
            <td>9</td>
            <td>Place of Birth(Village,City,Tal-Dist.)</td>
            <td class="tdata2">{{ lc_data.birth_place }}</td>
          </tr>
          <tr v-if="org_basic_data.school_name !== 'Zeal International School'">
            <td>10</td>
            <td>Date of Birth, Month & Year according to Christian Era</td>
            <td class="tdata2">{{ lc_data.dob_fig }}-{{ lc_data.dob_words }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 12 : 11 }}</td>
            <td>Last School Attended</td>
            <td class="tdata2">{{ lc_data.last_school }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 13 : 12 }}</td>
            <td>Date of Admission</td>
            <td class="tdata2">{{ lc_data.doa }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 14 : 13 }}</td>
            <td>Progress</td>
            <td class="tdata2">{{ lc_data.progress }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 15 : 14 }}</td>
            <td>Conduct</td>
            <td class="tdata2">{{ lc_data.conduct }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 16 : 15 }}</td>
            <td>Date of Leaving School</td>
            <td class="tdata2">{{ lc_data.last_date_of_school }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 17 : 16 }}</td>
            <td>Standard in which Studying & Since when</td>
            <td v-if="org_basic_data.id == 1" class="tdata2">{{ lc_data.standard }} {{ lc_data.standard_since_when }}</td>
            <td v-else class="tdata2">{{ lc_data.standard }} and {{ lc_data.standard_since_when }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 18 : 17 }}</td>
            <td>Reason of Leaving School</td>
            <td class="tdata2">{{ lc_data.reason }}</td>
          </tr>
          <tr>
            <td>{{ org_basic_data.school_name === 'Zeal International School' ? 19 : 18 }}</td>
            <td>Remarks</td>
            <td class="tdata2">{{ lc_data.remark }}</td>
          </tr>
        </table>
        <!-- lc table end -->
        <!-- <br /> -->
        <span style="font-size: 14px; font-family: arial">Certified that the above information is in accordance with the
          School
          Register </span><br />
        <span style="font-size: 14px; font-family: arial; font-weight: bold">Date :- {{ lc_data.gen_date
          }}</span><br />
        <div style="width: 100%">
          <center>
            <div dense style="
                width: 35%;
                display: inline-block;
                font-size: 14px;
                font-family: arial;
                font-weight: bolder;
              ">
              Class Teacher
            </div>
            <div dense style="
                width: 30%;
                display: inline-block;
                font-size: 14px;
                font-family: arial;
                font-weight: bolder;
              ">
              Clerk
            </div>
            <div dense style="
                width: 35%;
                display: inline-block;
                font-size: 14px;
                font-family: arial;
                font-weight: bolder;
              ">
              Principal<br />
              {{ org_basic_data.school_name }}
            </div>
          </center>
        </div>
      </div>
    </div>
    <!-- lc data code end -->
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      lc_data: null,
      org_basic_data: null,
      last_date_of_school: "",
    };
  },
  methods: {},
  mounted() {
    this.lc_data = JSON.parse(localStorage.getItem("lc_data"));
    this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
    this.last_date_of_school = localStorage.getItem("last_date_of_school");
  },
};
</script>
<style scoped>
.cardbody {
  border: 1px solid black;
  /* width: 740px; */
  display: inline-block;
  padding: 5px;
  padding-top: 5px;
  height: auto;
}

/* .radiobtn{
  display: inline !important;
} */

/* lc data css */

.header {
  /* border:2px solid;  */
  margin: 6px;
}

.trust-name {
  /* margin-left: 22%; */
  text-transform: uppercase;
}

.schl-name {
  font-size: 25px;
  text-transform: uppercase;
}

.adrs {
  /* margin-left: 33px; */
  margin-left: -10%;
}

.line1 {}

.line2 {}

.tdata2 {
  font-weight: bolder;
}

table {
  border: 1px solid black;
  border-collapse: collapse;
}

td {
  padding-left: 5px;
  padding-right: 4px;
  padding-top: 2px;
  padding-bottom: 2px;
}

/* print lc css */
@media print {

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }

  v-card {
    border: none !important;
  }
  .lc-table tr{
    font-size: 16px;
  }
  @page {
    size: A4;
    margin-bottom: 1.5% !important;
    margin: 3%;
    margin-top: 2% !important;
  }

  /* thead {
    font-weight: bold !important;
  } */
  /* table,
  tr,
  th {
    text-align: center !important;
    margin-top: none;
    padding: none !important;
    border-bottom: 1px solid black;
    border: 1px solid black;
  } */
}

/* print lc css end */

.style-1 {
  background-color: rgb(215, 84, 44);
  font-weight: bolder;
}

.style-2 {
  background-color: rgb(61, 219, 21);
}

span.stretch {
  display: inline-block;
  -webkit-transform: scale(1.5, 1);
  /* Safari and Chrome */
  -moz-transform: scale(1.3, 1);
  /* Firefox */
  -ms-transform: scale(1.5, 1);
  /* IE 9 */
  -o-transform: scale(1.5, 1);
  /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}

.stretch1 {
  display: inline-block;
  -webkit-transform: scale(1.3, 1);
  /* Safari and Chrome */
  -moz-transform: scale(1.3, 1);
  /* Firefox */
  -ms-transform: scale(1.5, 1);
  /* IE 9 */
  -o-transform: scale(1.5, 1);
  /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}

h3.stretch2 {
  display: inline-block;
  -webkit-transform: scale(2, 1);
  /* Safari and Chrome */
  -moz-transform: scale(1.5, 1);
  /* Firefox */
  -ms-transform: scale(1.5, 1);
  /* IE 9 */
  -o-transform: scale(1.5, 1);
  /* Opera */
}
</style>
